export default "__VITE_ASSET__7g4u$xvQ__"